import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class UploadEscudosPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "uploading", false);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "escudos", []);
    // Drag and drop state
    _defineProperty(this, "isDragging", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    this.loadEscudos();
  }
  loadEscudos() {
    this.loading = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/escudos'
    }).then(response => {
      this.escudos = response || [];
      this.loading = false;
      m.redraw();
    }).catch(e => {
      console.error('Error loading escudos:', e);
      this.loading = false;
      m.redraw();
    });
  }
  uploadFile(file) {
    if (!file) return;

    // Check if file is an image
    if (!file.type.match('image.*')) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.rivals.upload_error_not_image'));
      return;
    }
    this.uploading = true;
    m.redraw();
    const formData = new FormData();
    formData.append('escudo', file);
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/upload-escudo',
      serialize: raw => raw,
      // DO NOT JSON serialize
      data: formData
    }).then(response => {
      this.uploading = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('bizkaitarra-lineup.forum.rivals.upload_success'));
      this.loadEscudos(); // Reload list
    }).catch(e => {
      var _e$response;
      console.error('Upload error:', e);
      this.uploading = false;
      app.alerts.show({
        type: 'error'
      }, ((_e$response = e.response) == null ? void 0 : _e$response.error) || app.translator.trans('bizkaitarra-lineup.forum.rivals.upload_error'));
      m.redraw();
    });
  }
  onFileChange(e) {
    const files = e.target.files;
    if (files.length > 0) {
      this.uploadFile(files[0]);
    }
  }
  onDragOver(e) {
    e.preventDefault();
    this.isDragging = true;
  }
  onDragLeave(e) {
    e.preventDefault();
    this.isDragging = false;
  }
  onDrop(e) {
    var _e$dataTransfer;
    e.preventDefault();
    this.isDragging = false;
    const files = (_e$dataTransfer = e.dataTransfer) == null ? void 0 : _e$dataTransfer.files;
    if (files && files.length > 0) {
      this.uploadFile(files[0]);
    }
  }
  view() {
    if (!this.canManage) return null;
    return m("div", {
      className: "UploadEscudosPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.rivals'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.upload_back_rivals')), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-user-shield"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.nav_back_taldezaina'))), m("div", {
      className: "UploadEscudos-header",
      style: "margin-bottom: 30px;"
    }, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.upload_title')), m("p", {
      style: "color: var(--muted-color); font-size: 1.15em; margin-top: 8px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.upload_description'))), m("div", {
      ondragover: this.onDragOver.bind(this),
      ondragleave: this.onDragLeave.bind(this),
      ondrop: this.onDrop.bind(this),
      style: "background: ".concat(this.isDragging ? 'rgba(var(--primary-color-rgb), 0.05)' : 'rgba(255, 255, 255, 0.02)', "; border: 2px dashed ").concat(this.isDragging ? 'var(--primary-color)' : 'rgba(255, 255, 255, 0.15)', "; border-radius: 20px; padding: 50px 30px; text-align: center; cursor: pointer; transition: all 0.3s ease; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 15px; margin-bottom: 40px; box-shadow: inset 0 4px 20px rgba(0,0,0,0.15);"),
      onclick: () => {
        var _document$getElementB;
        return (_document$getElementB = document.getElementById('file-upload-input')) == null ? void 0 : _document$getElementB.click();
      }
    }, m("input", {
      type: "file",
      id: "file-upload-input",
      accept: "image/*",
      style: "display: none;",
      onchange: this.onFileChange.bind(this)
    }), this.uploading ? m("div", {
      style: "padding: 20px;"
    }, m(LoadingIndicator, null), m("span", {
      style: "display: block; font-weight: bold; margin-top: 15px; color: var(--heading-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.uploading_label'))) : m("fragment", null, m("div", {
      style: "font-size: 4.5rem; color: var(--primary-color); filter: drop-shadow(0 4px 10px rgba(0,0,0,0.25));"
    }, m("i", {
      className: "fas fa-cloud-upload-alt"
    })), m("div", null, m("span", {
      style: "font-size: 1.25em; font-weight: 800; color: var(--heading-color); display: block; margin-bottom: 5px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.upload_drag_help')), m("span", {
      style: "color: var(--muted-color); font-size: 0.95em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.upload_click_help'))), m("span", {
      style: "font-size: 0.85em; background: rgba(255,255,255,0.06); padding: 5px 12px; border-radius: 20px; color: var(--muted-color); border: 1px solid rgba(255,255,255,0.04); margin-top: 5px;"
    }, "Formatos permitidos: PNG, JPG, JPEG, GIF, SVG, WEBP"))), m("div", {
      style: "background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 20px; padding: 30px;"
    }, m("h3", {
      style: "font-size: 1.4em; font-weight: bold; margin: 0 0 25px 0; color: var(--heading-color); border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 15px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.gallery_title'), " (", this.escudos.length, ")"), this.loading ? m(LoadingIndicator, null) : m("div", {
      style: "display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 20px;"
    }, this.escudos.map(escudo => m("div", {
      key: escudo.filename,
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 15px; display: flex; flex-direction: column; align-items: center; gap: 12px; transition: transform 0.2s ease, border-color 0.2s ease; cursor: default;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-5px)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.2)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.08)';
        });
      }
    }, m("div", {
      style: "height: 70px; width: 70px; display: flex; align-items: center; justify-content: center;"
    }, m("img", {
      src: escudo.url,
      alt: escudo.filename,
      style: "max-height: 100%; max-width: 100%; object-fit: contain;"
    })), m("span", {
      style: "font-size: 0.8em; text-align: center; color: var(--muted-color); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; display: block;",
      title: escudo.filename
    }, escudo.filename))), this.escudos.length === 0 && m("div", {
      style: "grid-column: 1 / -1; text-align: center; padding: 40px; color: var(--muted-color); font-style: italic;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.empty_gallery'))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/UploadEscudosPage', UploadEscudosPage);